import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Authentication } from '@core/services';

/**
 * los Guards
 * controlan las rutas de navegación entre páginas de la aplicación web, permitiendo o denegando el acceso por ejemplo
 */

export const authenticationGuard: CanActivateFn = (route, state) => {
  const auth = inject(Authentication);
  // si el usuario esta logueado retornara true; caso contrario un false
  if (auth.isAuthenticated()) {
    return true;
  }

  const router = inject(Router);
  router.navigate(['home']);
  // en caso de no estar logueado podemos redireccionarlo donde se desee
  return false;
};
